/*jshint laxcomma:true */
/*global matchMedia:false, Modernizr:false, console:false */
$(document).ready(function () {
    "use strict";
    var
        cycleTime = 3750 //3750
        , lookbookCycleTime = 15625 //15625
        , fadeDuration = 1000 //1000
        , manualFadeDuration = 500 //500
        , showcaseInterval
        , imgs = []
    ;
    
    // http://stackoverflow.com/a/901144/214325
    function getParameterByName(name)
    {
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");

        var
            regexS = "[\\?&]" + name + "=([^&#]*)"
            , regex = new RegExp(regexS)
            , results = regex.exec(window.location.search)
        ;

        if (results == null)
        {
            return "";
        }

        return decodeURIComponent(results[1].replace(/\+/g, " "));
    }
	
	function labelize() {
		$("dl.hinted dt > label").inFieldLabels({'fadeDuration':150});
	}
	
	function viewLarger(fullsize) {
		if (matchMedia('only screen and (min-width: 35em)').matches && matchMedia('only screen and (min-height: 15em)').matches) {
			if(typeof fullsize === 'undefined' || !fullsize) {
				throw new Error('Missing parameter "fullsize"');
			}
		
			var
				modal = $('div[data-uid="' + fullsize + '"]') // img url doubles as unique id
			;

			$('.modal').hide();

			// if modal does not already exist
			if(!modal.length) {
				// should ideally be converted to ajax

				var modalMarkup = '<div data-uid="' + fullsize + '" class="modal">\
					<div class="content">\
					<nav>\
						<a class="x" role="img button" title="Dismiss">&times;</a>\
						<div class="prev-next">\
							<a class="prev" role="img button" title="Previous product view" href="javascript:void(0);">&#9664;</a>\
							<a class="next" role="img button" title="Next product view" href="javascript:void(0);">&#9654;</a>\
						</div>\
					</nav>\
					<img src="' + fullsize + '" />\
					</div>\
					</div>'
					, modalEl = $(modalMarkup).height(getModalHeight)
				;
			
				modalEl.insertAfter('[role="banner"]');

				$('.x').on('click', function() {
					closeModal(this);
				});
				
				$('.modal .next').on('click', function nextModal() {
					advanceModal(this, 1);
				});
				
				$('.modal .prev').on('click', function nextModal() {
					advanceModal(this, -1);
				});

				modalEl.on('click', function() {
					closeModal(this);
				}).children().on('click', function(event) {event.stopPropagation();});
			} else {
				modal.show().on('click', function() {
					closeModal(this);
				}).children().on('click', function(event) {event.stopPropagation();});
			}
			return false;
		} // matchMedia
		return true;
	}
	
	function advanceModal(obj, step) {
		// .modal -> uid -> find in ul.preview -> closeModal -> viewLarger

		var
			currentModal = $(obj).closest('.modal')
			, currentModalUid = currentModal.attr('data-uid')
			, currentModalPreviewLi = $('.preview').find('a[href="' + currentModalUid + '"]').parent('li')
			, all = currentModalPreviewLi.parent().children()
			, total = all.length - 1
			, pos = currentModalPreviewLi.index()
			, newPos = pos + step
			, newPreviewLi
			, newModalUid
		;
		
		console.log(total)
		console.log(newPos);
		
		if (newPos > total)
		{
			newPreviewLi = all.eq(0);
		}
		else if (newPos < 0)
		{
			newPreviewLi = all.last();
		}
		else
		{
			newPreviewLi = all.eq(newPos);
		}

		newModalUid = newPreviewLi.children('a').eq(0).attr('href');
		
		console.log(newPreviewLi);

		closeModal(obj);
		viewLarger(newModalUid);
	}
	
	function closeModal(obj, soft) {
		var
			modal = $(obj).closest('.modal')
		;
		soft = soft || false;
				
		if (soft) {
			modal.hide();
		} else {
			modal.remove();
		}
		
		window.location.hash = '';
		return false;
	}
	
	function getModalHeight() {
		if(matchMedia('only screen and (min-width: 55em)').matches) {
			return $(document).height();
		}
		return 'auto';
	}
	
	function modalResize() {
		$('.modal').css('height', getModalHeight);
	}
	
	function imgResize(display, img) {
		img = img || display.find('img');
		
		var
			imgHeight = img.height()
		;

		if (imgHeight > 0)
		{
			display.css({'height': imgHeight});
		}
		
		if (matchMedia('only screen and (min-width: 55em)').matches) {
			if ($('#lookbook').length > 0) {
				var
					displayWidth = display.outerWidth()
					, totalWidth = $('[role="main"]').outerWidth()
					, buyWidth = display.closest('.season').find('aside').eq(0).outerWidth()
					, availableWidth = totalWidth - buyWidth
					, displayTooBigOrSmall = (displayWidth !== availableWidth)
				;
			
				if (displayTooBigOrSmall) {
					display.css({'width': availableWidth});
				}
			}
		} else { // matchMedia
			display.css({'width': ''});
		}
	}
	
	function activateTabs() {
		//$('#brands [role="main"] section:not(:first), #lookbook .season:not(:first)').addClass('tab'); //.hide();
		
		var tabLinks = $('#brands [role="complementary"] a, #lookbook [role="complementary"] a');
		
		tabLinks.eq(0).addClass('here');
		
		tabLinks.on('click', function (event) {
			var
				link = $(this)
				, href = link.attr('href')
				, section = $(href)
				, display = section.find('.display')
			;
			
			showFeaturedProducts(null, display);
			imgResize(display);
			
			$('#brands [role="main"] section, #lookbook .season').hide();
			link.parent('li').siblings().children('a').removeClass('here');
			
			section.show();
			link.addClass('here');
			
			event.preventDefault();
		});
	}
	
	function showFeaturedProducts(imageLink, refDisplay) {
		if ($('#lookbook').length > 0) {
			imageLink = imageLink || refDisplay.parent('.view').siblings('.prev-next').eq(0).children('li').eq(0).children('a');

			var
				dataProducts = imageLink.attr('data-products')
				, featuredProducts
				, productLinks
				, productList = {}
			;
			
			if ((typeof dataProducts !== 'undefined') && dataProducts.length > 0) {
				dataProducts = dataProducts.toLowerCase();
				featuredProducts = dataProducts.split(', ');
				
				productLinks = refDisplay.closest('.slideshow').siblings('aside').eq(0).children('ul').eq(0).children('li').hide().find('a');			
				productLinks.each(function () {
					var
						productLink = $(this)
						, key = productLink.text().toLowerCase()
					;
					
					//productList.push(key);
					productList[key] = productLink;
				});
				
				$.each(featuredProducts, function () {
					var featuredProduct = this;
					
					if (productList.hasOwnProperty(featuredProduct)) {
						productList[featuredProduct].parent('li').show();
					}
				});
				
				return imageLink;
			} // endif
		}
		return false;
	}
	
	/*
		Changes the currently-displayed image in the showcase
			@event event object
			@newImageLink jQuery object of <a href="[image to change to]">
			@refDisplay Which <div class="display"> (wrapper that contains the image) to use as reference point
			@immediate Boolean, Change to the immediately following image or not
	*/
	function changeShowcaseImage(event, newImageLink, refDisplay, pageLink, fadeTiming) {
		event = event || false;
		//newImageLink = newImageLink || $(this);
		// refDisplay - see below
		//immediate = immediate || false;
		pageLink = pageLink || 'javascript:void(0)';
        fadeTiming = fadeTiming || fadeDuration;

		var
			nav = newImageLink.closest('ul')
			, allLinks = nav.find('a')
			, imgLink = refDisplay.children('a').eq(0)
			, oldImg = refDisplay.children('img:visible').eq(0)
			, href = newImageLink.attr('href')
			, title = newImageLink.attr('title')
			, img
			, newImg
			, arrowLeft
			, arrowRight
			, transitioning
		;
		
		refDisplay = refDisplay || nav.siblings('.view').children('.display').eq(0);
		transitioning = refDisplay.attr('data-transitioning');

		// Only proceed if the slideshow is not in the process of transitioning
		if(typeof transitioning === 'undefined' || transitioning === 'false' || transitioning === false)
		{
			refDisplay.attr('data-transitioning', 'true');
			
			if(oldImg.length === 0 && imgLink.length > 0) {
				oldImg = imgLink.children('img:visible').eq(0);
			}
			
			if(typeof(imgs[href]) !== "undefined" && imgs[href].length > 0) {
				img = imgs[href];
			} else {
				img = $('<img alt="' + title + '" src=' + href + '" />');
			}
	
			// Only do this not on the homepage
			if($('#home').length === 0) {
				newImg = img.css('cursor', 'pointer').attr('title', 'Next slide').hide();
				
				newImg.on('click', function (event) {
					advanceShowcaseImage(event, refDisplay, 1, null, manualFadeDuration);
				});
				
				refDisplay.append(img);
			} else {
				newImg = img.hide();
				
				if(imgLink) { // length
					imgLink.attr('href', pageLink);
					imgLink.append(img);
				}
			}
		
			$(window).on('resize orientationchange', function () {
				imgResize(refDisplay, newImg);
			});
	
			oldImg.stop(true).fadeOut(fadeDuration, function() {
				$(this).remove();
			});
	
			newImg.fadeIn(fadeDuration, function () {
				allLinks.removeClass('here');
				newImageLink.addClass('here');
				refDisplay.attr('data-transitioning', 'false');
				
				showFeaturedProducts(newImageLink, refDisplay);
				
				//if(!immediate) {
					cycleShowcaseImages(true);
				//}
			});
			
			//console.log('newImageLink.length', newImageLink.length);
	
			if (event) { event.preventDefault(); }
		} // if
	} // changeShowcaseImage
	
	var
		i = 0
		, allSlideshows = $('.slideshow')
	;
	
	allSlideshows.find('img').imagesLoaded(function imagesLoaded() {
		allSlideshows.each(function () {
			var
				slideshow = $(this)
				, display = slideshow.children('.view').children('.display')
				, img
				, slides = slideshow.children('ul').eq(0).find('a')
			;
			
			if (i === 0) {
				showFeaturedProducts(null, display);
			}
			
			if($('#home').length > 0) {
				img = display.find('a > img').eq(0);
			} else {
				img = display.children('img').eq(0).css('cursor', 'pointer').attr('title', 'Next slide'); // should turn this into real link as well
				img.on('click', function (event) {
					advanceShowcaseImage(event, display, 1, null, manualFadeDuration);
				});
			}

			imgResize(display, img);
			$(window).on('resize orientationchange', function () {
				imgResize(display, img);
			});
		
			slides.each(function () {
				var
					slide = $(this)
					, href = slide.attr('href')
					, title = slide.attr('title')
					, img = $('<img alt="' + title + '" src="' + href + '" />')
					, page = slide.attr('data-page')
				;

				imgs[href] = img;

				slide.on('click', function (event) {
					changeShowcaseImage(event, $(this), display, null, page, manualFadeDuration);
				});
			});
		
			++i;
			
			if(i === allSlideshows.length) {
				activateTabs();
			}
		});
	});
	
	/* Does this selector point to element on the currently displayed page? Returns jQuery object or false. */
	function test(selector) {
		var display = $(selector);
		if (display.length > 0) {
			return display;
		}
		return false;
	}
	
	/* Convenience function: Is this the Brands slideshow? Return Boolean */
	function isBrands() {
		return test('[role="main"] > .content > section:visible > header > .slideshow .display');
	}
	
	/* Convenience function: Is this the Lookbook slideshow? Returns Boolean */
	function isLookbook() {
		return test('[role="main"] > .season:visible > .slideshow .display');
	}
	
	/*
		Advances/regresses the currently displayed showcase image
			@event event object
			@refDisplay jQuery object, Which <div class="display"> wrapper to use as reference point
			@step int, Number of images forward (+) or backward (-) in list order to get to the desired image
			@immediate Boolean, change to immediately following image or not (@todo: necessary? can be inferred from step)
	*/
	function advanceShowcaseImage(event, refDisplay, step, pageLink, fadeTiming)
	{
		var
			lookbookDisplay
			, brandsDisplay
		;
		event = event || false;
		//immediate = immediate || false;
		step = step || 1;
        fadeTiming = fadeTiming || fadeDuration;
		
		if (!refDisplay) {
			lookbookDisplay = isLookbook();
			if (lookbookDisplay) {
				refDisplay = lookbookDisplay;
			} else {
				brandsDisplay = isBrands();
				if (brandsDisplay) {
					refDisplay = brandsDisplay;
				} else {
					refDisplay = $('[role="main"] .slideshow:first .display');
				}
			}
		}

		var
			nav = refDisplay.parent().siblings('ul').eq(0)
			, li = nav.children('li')
			, total = li.length - 1 // compensate for 0-based
			, here = nav.find('.here')
			, pos = here.parent().index()
			, newPos = pos + step
			, newImageLi = (newPos > total) ? li.eq(0) : li.eq(newPos)
			, newImageLink = newImageLi.find('a')
			, pageLink = newImageLink.attr('data-page')
		;
        
        //console.log('newImageLink.length', newImageLink.length);
		changeShowcaseImage(event, newImageLink, refDisplay, pageLink, fadeTiming);
	}
	
	function cycleShowcaseImages(reset) {
		if($('.slideshow').length > 0) {
			var interval;
			reset = reset || false;
			
			if($('#lookbook').length > 0) {
				interval = lookbookCycleTime;
			} else {
				interval = cycleTime;
			}
			
			//if(reset) {
				clearInterval(showcaseInterval);
			//}
			
			showcaseInterval = setInterval(function () {
				advanceShowcaseImage(false, false, false, true);
			}, interval);
		}
	}
	
	try {
		if(Modernizr.inputtypes.search) {
			$('html').addClass('search');
		}
		
		$('details').details();
		labelize();
		
		$('[action="/cart/add"]').on('submit', function (event) {
			var
				form = $(this)
				, action = form.attr('action')
				, data = form.serialize()
				, qty = parseInt(form.find('#qty').val(), 10)
				, itemCount = $('#item-count')
				, itemCountInt = parseInt(itemCount.html(), 10)
			;
			
			$.post(action, data, function success (responseData) {
				var cart;

				itemCount.html(itemCountInt + qty);
				itemCountInt = parseInt(itemCount.html(), 10);
				
				cart = $(responseData).find('#cart > .cart'); // :first for sanity check?
				cart.addClass('modal').attr('id', 'shopping-cart').height(getModalHeight);
				cart.find('.content').removeClass('content');
				cart.wrapInner('<div class="content" />');
				cart.find('.content').prepend('<nav><a class="x" role="img button" href="javascript:void(0);" title="Dismiss">&times;</a></nav>');
				
				cart.find('.remove-review > a').on('click', function(event) {
					var
						link = $(this)
						, row = link.closest('tr')
						, href = link.attr('href')
						, removeQty = parseInt(row.find('.qty-review > input').val(), 10)
						, newQty = itemCountInt - removeQty
					;
					
					itemCount.html(newQty);
					itemCountInt = newQty;
					
					$.ajax(href).success(function() {
						row.remove();
					});

					event.preventDefault();
				});
				
				cart.find('.x').on('click', function() {
					closeModal(this);
				});

				cart
					.on('click', function() {
						closeModal(this);
					})
					.children().on('click', function(event) {
						event.stopPropagation();
					})
				;
				$('#top').after(cart);
				window.location.hash = 'shopping-cart';
			}, 'html');
			
			event.preventDefault();
		});
	
		$('.gallery > .content > a, .gallery .preview a').each(function () {
			var 
				link = $(this)
				, fullsize = link.attr('href')
			;

			link.on('click', function () {
				return viewLarger(fullsize);
			});
		});
		
		if($('#home').length > 0) {
			// Add images to the DOM; would prefer pseudos here but they don't work with events
			var
				arrowLeft = $('.arrow.left')
				, arrowRight = $('.arrow.right')
				, refDisplay = $('#home > .content > .slideshow .display').eq(0)
				, img = refDisplay.find('img')
			;
			
			arrowLeft.on('click', function (event) {
				advanceShowcaseImage(event, refDisplay, -1, manualFadeDuration);
			});
			
			arrowRight.on('click', function (event) {
				advanceShowcaseImage(event, refDisplay, 1, manualFadeDuration);
			});

			//imgResize(refDisplay, img);
		}
        
        if( ($('#shop').length > 0) && window.location.href.indexOf('vendors') > 0 )
        {
            var
                details = $('#shop-by-brand > details')
                , brand = getParameterByName('q')
            ;

            details.attr({'open': 'open', 'class': 'open'});
            details.children('ul').find('a:contains(' + brand + ')').eq(0).attr('class', 'here');
        }
		
		cycleShowcaseImages();
		
		//modalResize();
		$(window).on('resize orientationchange', modalResize);
	} catch(e) {
		console.log(e.message);
	}
});